var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body shadow-sm"},[_vm._v(" sales rep profile ")])])])}]

export { render, staticRenderFns }